import React from 'react';
function PageLoadingCirc() {
	return (
		<svg id="loadingsvg" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 183 200">
			<ellipse className="loading st0" cx="162.4" cy="48.5" rx="20.6" ry="20.7"/>
			<ellipse className="loading st1" cx="111.9" cy="19.1" rx="19.1" ry="19.1"/>
			<ellipse className="loading st2" cx="54" cy="29.2" rx="18" ry="18.1"/>
			<ellipse className="loading st3" cx="16.6" cy="74.7" rx="16.6" ry="16.6"/>
			<ellipse className="loading st4" cx="16.6" cy="133.2" rx="14.9" ry="14.9"/>
			<ellipse className="loading st5" cx="54" cy="178.1" rx="13.3" ry="13.3"/>
			<ellipse className="loading st6" cx="111.9" cy="188.2" rx="11.8" ry="11.8"/>
			<ellipse className="loading st7" cx="162.3" cy="158.6" rx="9.3" ry="9.4"/>
		</svg>
	);
}
export default PageLoadingCirc;


/** WEBPACK FOOTER **
 ** ./src/modules/images/PageLoadingCirc.js
 **/